import React from 'react';
import { testimonials } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
import { Stars } from '../ui/Stars';
export function TestimonialsGrid() {
  return <section aria-labelledby="testimonios-title" className="w-full bg-ink-800" data-id="element-215" data-mp="3m4i44sehypx0">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-216" data-mp="3m6ksl8004azm">
        <div className="max-w-3xl" data-id="element-217" data-mp="3r2ryj0sedmhk">
          <SectionLabel data-id="element-218" data-mp="3r55vjf6n18rr">Familias colombianas que ya acompañan con información</SectionLabel>
          <h2 id="testimonios-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-219" data-mp="2thxblomac7rv">
            Lo que cuentan papás y mamás de las principales ciudades de Colombia
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-220" data-mp="38eenqi2atqfh">
          {testimonials.map(item => <figure key={item.initials} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6 shadow-panel transition-transform duration-150 ease-out hover:-translate-y-1" data-id="element-221" data-mp="in8623zjw83k">
              <div className="flex items-center gap-3" data-id="element-222" data-mp="fedrool3akoa">
                <span aria-hidden="true" className="flex h-11 w-11 items-center justify-center rounded-full text-sm font-black text-white" style={{
              backgroundColor: item.color
            }} data-id="element-223" data-mp="fcssumrqsfkm">
                  {item.initials}
                </span>
                <Stars data-id="element-224" data-mp="1gywt4c2hkox" />
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] italic leading-relaxed text-body" data-id="element-225" data-mp="3stjv1o6al37x">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-ink-border pt-4" data-id="element-226" data-mp="3nscjde113jvz">
                <span className="block text-sm font-bold text-white" data-id="element-227" data-mp="3juycvu4qfq7o">{item.name}</span>
                <span className="block text-sm text-subtle" data-id="element-228" data-mp="3espkayvruq63">{item.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}